import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient as ReactApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import config from 'commons-general/config/index.js';
import { LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';

class ApolloClient {
    _create() {
        const link = new HttpLink({
            uri: config.endpoint.graphql,
            headers: {
                'accept-language': LocaleService.getLocale(),
            },
        });

        this.client = new ReactApolloClient({
            connectToDevTools: !!WindowProxy.get(),
            link,
            partialResultsOnError: true,
            cache: new InMemoryCache(),
        });

        return this.client;
    }

    /**
     * Initialize an Apollo Client or return it if it's aleady initialized
     * @returns {ApolloClient}
     */
    getOrCreate() {
        return this.client || this._create();
    }
}

export { ReactApolloClient };

export default new ApolloClient();



// WEBPACK FOOTER //
// ./src/clients/ApolloClient/ApolloClient.js